import { z } from 'zod'

export function isZodError<T>(error: unknown): error is z.ZodError<T> {
  return error instanceof z.ZodError
}
